import { translitToRus } from 'app/utils';
import { filterAndSortTransportItems } from 'app/utils/mapTransportList';
import { createSelector } from 'reselect';
const mapState = (state) => state.map;
export const refMapSelector = createSelector(mapState, (map) => map.ref);
export const zoomMapSelector = createSelector(mapState, (map) => map.zoom);
export const boundsMapSelector = createSelector(mapState, (map) => map.bounds);
export const layerSelectedMapSelector = createSelector(mapState, (map) => map.layerSelected);
export const geofenceModeMapSelector = createSelector(mapState, (map) => map.geofenceMode);
export const activeWindowMapSelector = createSelector(mapState, (map) => map.activeWindow);
export const transportWindowMinimizeMapSelector = createSelector(mapState, (map) => map.transportWindowMinimize);
export const transportTabMapSelector = createSelector(mapState, (map) => map.transportTab);
export const filterTabMapSelector = createSelector(mapState, (map) => map.filterTab);
export const transportItemsMapSelector = createSelector(mapState, (map) => map.transportItems);
export const transportSelectedItemMapSelector = createSelector(mapState, (map) => map.transportSelectedItem);
export const transportSelectedDateMapSelector = createSelector(mapState, (map) => map.transportSelectedDate);
export const transportConditionItemsMapSelector = createSelector(mapState, (map) => map.transportConditionItems);
export const transportFilterCheckedTypeMapSelector = createSelector(mapState, (map) => map.transportFilterCheckedType);
export const transportCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportCheckedItems);
export const transportMarkedCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportMarkedCheckedItems);
export const transportProcessingCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportProcessingCheckedItems);
export const transportSortSelectedItemMapSelector = createSelector(mapState, (map) => map.transportSortSelectedItem);
export const transportFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportFilterCheckedItems);
export const transportColumnCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportColumnCheckedItems);
export const transportConditionFilterCheckedTypeMapSelector = createSelector(mapState, (map) => map.transportConditionFilterCheckedType);
export const transportConditionFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportConditionFilterCheckedItems);
export const transportBroadcastSelectedItemMapSelector = createSelector(mapState, (map) => map.transportBroadcastSelectedItem);
export const transportConditionSelectedItemMapSelector = createSelector(mapState, (map) => map.transportConditionSelectedItem);
export const transportConditionSelectedDatetimeMapSelector = createSelector(mapState, (map) => map.transportConditionSelectedDatetime);
export const transportActivityQueueMapSelector = createSelector(mapState, (map) => map.transportActivityQueue);
export const transportConditionQueueMapSelector = createSelector(mapState, (map) => map.transportConditionQueue);
export const transportSearchValueMapSelector = createSelector(mapState, (map) => map.transportSearchValue);
export const transportGeofenceViewMapSelector = createSelector(mapState, (map) => map.transportGeofenceView);
export const geofenceItemsMapSelector = createSelector(mapState, (map) => map.geofenceItems);
export const geofenceUpdatedItemMapSelector = createSelector(mapState, (map) => map.geofenceUpdatedItem);
export const geofenceChangedItemMapSelector = createSelector(mapState, (map) => map.geofenceChangedItem);
export const geofenceUpdatedModeMapSelector = createSelector(mapState, (map) => map.geofenceUpdatedMode);
export const geofenceCheckedIdMapSelector = createSelector(mapState, (map) => map.geofenceCheckedId);
export const geofenceGroupItemsMapSelector = createSelector(mapState, (map) => map.geofenceGroupItems);
export const geofenceGroupItemsLimitMapSelector = createSelector(mapState, (map) => map.geofenceGroupItemsLimit);
export const geofenceSearchValueMapSelector = createSelector(mapState, (map) => map.geofenceSearchValue);
export const taskItemsMapSelector = createSelector(mapState, (map) => map.taskItems);
export const taskSelectedItemMapSelector = createSelector(mapState, (map) => map.taskSelectedItem);
export const taskSortSelectedItemMapSelector = createSelector(mapState, (map) => map.taskSortSelectedItem);
export const taskFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.taskFilterCheckedItems);
export const taskColumnCheckedItemsMapSelector = createSelector(mapState, (map) => map.taskColumnCheckedItems);
export const taskSearchValueMapSelector = createSelector(mapState, (map) => map.taskSearchValue);
export const notificationEventsMapSelector = createSelector(mapState, (map) => map.notificationEvents);
export const transportSelectedItemBroadcastMapSelector = createSelector(transportSelectedItemMapSelector, (transportSelectedItem) => transportSelectedItem.broadcast);
export const transportSelectedItemConditionsMapSelector = createSelector(transportSelectedItemMapSelector, (transportSelectedItem) => transportSelectedItem.conditions);
export const sortItemsFilterGeofenceListSelector = createSelector([geofenceGroupItemsMapSelector, geofenceSearchValueMapSelector], (geofenceGroupItems, geofenceSearchValue) => {
    return geofenceGroupItems.map((currentValue) => {
        if (geofenceSearchValue.length !== 0) {
            return currentValue.geofences.filter((geofence) => translitToRus(geofence.name).indexOf(translitToRus(geofenceSearchValue)) !== -1);
        }
        return currentValue;
    });
});
export const sortItemsFlatMapSelector = createSelector([sortItemsFilterGeofenceListSelector, geofenceSearchValueMapSelector], (sortItems, geofenceSearchValue) => {
    const flat = sortItems.reduce((acc, item) => acc.concat(item), []);
    if (geofenceSearchValue.length === 0) {
        return [...flat].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }
    const searchNorm = translitToRus(geofenceSearchValue).toLowerCase();
    const itemsWithMeta = flat.map((item) => {
        const name = item.name || '';
        const nameTranslit = translitToRus(name).toLowerCase();
        return {
            item,
            name,
            nameTranslit,
            startsWithSearch: nameTranslit.startsWith(searchNorm),
        };
    });
    return itemsWithMeta
        .sort((a, b) => {
        if (a.startsWithSearch && !b.startsWithSearch)
            return -1;
        if (!a.startsWithSearch && b.startsWithSearch)
            return 1;
        return a.name.localeCompare(b.name);
    })
        .map((meta) => meta.item);
});
export const sortItemsTaskListMapSelector = createSelector([taskItemsMapSelector, taskFilterCheckedItemsMapSelector, taskSortSelectedItemMapSelector, taskSearchValueMapSelector], (taskItems, taskFilterCheckedItems, taskSortSelectedItem, taskSearchValue) => {
    const compareFn = (a, b) => {
        switch (taskSortSelectedItem.name) {
            case 'transport_number':
                switch (taskSortSelectedItem.order) {
                    case 'ASC':
                        return a.transport_number.localeCompare(b.transport_number, { sensitivity: 'base' });
                    case 'DESC':
                        return b.transport_number.localeCompare(a.transport_number, { sensitivity: 'base' });
                }
                break;
            case 'task_date':
            case 'finished_date':
                switch (taskSortSelectedItem.order) {
                    case 'ASC':
                        return moment(a[taskSortSelectedItem.name]).valueOf() - moment(b[taskSortSelectedItem.name]).valueOf();
                    case 'DESC':
                        return moment(b[taskSortSelectedItem.name]).valueOf() - moment(a[taskSortSelectedItem.name]).valueOf();
                }
                break;
            default:
                switch (typeof a[taskSortSelectedItem.name]) {
                    case 'string':
                        switch (taskSortSelectedItem.order) {
                            case 'ASC':
                                return a.status.localeCompare(b.status, {
                                    sensitivity: 'base',
                                });
                            case 'DESC':
                                return b.status.localeCompare(a.status, {
                                    sensitivity: 'base',
                                });
                        }
                        break;
                    case 'number':
                        switch (taskSortSelectedItem.order) {
                            case 'ASC':
                                return a[taskSortSelectedItem.name] - b[taskSortSelectedItem.name];
                            case 'DESC':
                                return b[taskSortSelectedItem.name] - a[taskSortSelectedItem.name];
                        }
                        break;
                }
        }
    };
    const items = taskItems.reduce((accumulator, currentValue) => {
        if (accumulator.findIndex((item) => item.id === currentValue.id) !== -1) {
            return accumulator;
        }
        if (taskFilterCheckedItems.indexOf('active') !== -1) {
            if (currentValue.status === 'active') {
                return [...accumulator, currentValue];
            }
        }
        if (taskFilterCheckedItems.indexOf('finished') !== -1) {
            if (currentValue.status === 'finished') {
                return [...accumulator, currentValue];
            }
        }
        return accumulator;
    }, []);
    if (taskSearchValue.length) {
        return items.filter((item) => translitToRus(item.transport_number).indexOf(translitToRus(taskSearchValue)) !== -1).sort(compareFn);
    }
    return items.sort(compareFn);
});
export const transportCheckedItemsWithTypeMapSelector = createSelector([transportFilterCheckedTypeMapSelector, transportProcessingCheckedItemsMapSelector, transportCheckedItemsMapSelector], (type, transportProcessingCheckedItems, transportCheckedItems) => {
    if (type === 'filter') {
        return transportProcessingCheckedItems;
    }
    return transportCheckedItems;
});
export const sortItemsFilterTransportListMapSelector = createSelector([transportItemsMapSelector, transportFilterCheckedItemsMapSelector, transportSortSelectedItemMapSelector], (transportItems, transportFilterCheckedItems, transportSortSelectedItem) => {
    return filterAndSortTransportItems(transportItems, transportFilterCheckedItems, transportSortSelectedItem, moment());
});
export const searchItemsTransportMapSelector = createSelector([sortItemsFilterTransportListMapSelector, transportSearchValueMapSelector, transportSortSelectedItemMapSelector], (sortItems, transportSearchValue, transportSortSelectedItem) => {
    if (transportSearchValue.length) {
        return sortItems.filter((item) => {
            if (transportSortSelectedItem.name === 'geofence') {
                return translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1 || translitToRus(item.geofence_name).indexOf(translitToRus(transportSearchValue)) !== -1;
            }
            return translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1;
        });
    }
    return sortItems;
});
